import { ProductCardData } from '../../product-card/product-card-display';
import { PaymentOrderItemData } from '../../order-confirmation/order-completion.interface';
import { FreeTrialInfo, FreeTrialStatus } from '../interfaces/free-trial-info.interface';

export const mapProductToFreeTrialInfo = (product: ProductCardData | PaymentOrderItemData): FreeTrialInfo => {
  return {
    isFreeTrial: product.isFreeTrial,
    startDate: product.freeTrialStartDate,
    endDate: product.freeTrialEndDate,
    subscriptionUnitPrice: product.freeTrialSubscriptionUnitPrice,
    subscriptionAmount: product.freeTrialSubscriptionAmount,
    status: FreeTrialStatus.ACTIVE
  }
}